import {
  ActionIcon,
  Button,
  Card,
  Drawer,
  Group,
  LoadingOverlay,
  Modal,
  ScrollArea,
  Select,
  SimpleGrid,
  Table,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { showNotification } from "@mantine/notifications";
import EditIcon from "@mui/icons-material/Edit";
import axios from "axios";
import ActionButton from "components/controls/ActionButtonNew";
import { FeedbackUpdate } from "components/feedBack/FeedbackUpdate";
import { customLoader } from "components/utilities/loader";
import { useEffect, useState } from "react";
import { FiEye } from "react-icons/fi";
import { Plus, Trash } from "tabler-icons-react";
import { API, formatNumber, PAGE_SIZE_OPTIONS } from "utiles/url";
import { Add } from "./add";
import FeedbackTypeDetailModal from "./feedbacktypeDetail";
export default function FeedbackTypes({}) {
  const [data, setData] = useState([]);
  const [opened, setOpened] = useState(false);
  const [editData, setEditData] = useState([]);
  const [size, setSize] = useState("10");
  const handlePageSizeChange = (newSize) => {
    setSize(newSize);
    setActivePage(1);
    fetchData(newSize);
  };
  const [activePage, setActivePage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  useEffect(() => {
    fetchData(size);
  }, []);

  const fetchData = async (size) => {
    try {
      let token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.get(
        `${API}/feedback-types?page=${activePage}&first=${size}`,
        config,
      );
      if (response.data) {
        setData(response.data.data);
        setTotalPages(response.data.paginatorInfo.lastPage);
        setTotalRecords(response.data.paginatorInfo.total);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  const [openedDetail, setOpenedDetail] = useState(false);
  const [openedEdit, setOpenedEdit] = useState(false);
  const [openedDelete, setOpenedDelete] = useState(false);
  const [feedback, setFeedback] = useState(null);
  const handleDetail = (row) => {
    setFeedback(row);
    setOpenedDetail(true);
  };
  const handleEdit = (item) => {
    setEditData(item);
    setOpenedEdit(true);
  };
  const handleDelete = (item) => {
    setOpenedDelete(true);
    setEditData(item);
  };

  const deleteFeedbacktype = async () => {
    try {
      let token = localStorage.getItem("auth_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const response = await axios.delete(
        `${API}/feedback-types/${editData.id}`,
        config,
      );
      console.log(response.data);
      if (response.data) {
        fetchData(size);
        setOpenedDelete(false);
        setEditData(null);
        showNotification({
          color: "green",
          title: "Success",
          message: "Data Deleted Successfully",
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setOpenedDelete(false);
      setEditData(null);
      showNotification({
        color: "red",
        title: "Error",
        message: `Data Not Deleted Successfully`,
      });
    }
  };
  const handleChange = (page) => {
    setActivePage(page);
    fetchData(size);
  };
  const theme = useMantineTheme();
  const rows = data?.map((element) => (
    <tr key={element.id}>
      <td>
        <span>{element.id}</span>
      </td>
      <td>{element.name}</td>
      <td>{element.status}</td>
      <td>{element.feedbacks?.length}</td>
      <td>
        {new Date(element?.created_at).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </td>
      <td style={{ display: "flex", gap: "6px" }}>
        <ActionButton label="Edit" onClick={() => handleEdit(element)}>
          <EditIcon style={{ fontSize: "1rem" }} />
        </ActionButton>
        <ActionButton
          color="success"
          title="View Detail"
          onClick={() => handleDetail(element.feedbacks)}
        >
          <FiEye fontSize="medium" />
        </ActionButton>
        <ActionButton
          color="error"
          label="Delete"
          onClick={() => handleDelete(element)}
        >
          <Trash size={17} />
        </ActionButton>
      </td>
    </tr>
  ));
  return data?.length === 0 ? (
    <LoadingOverlay
      visible={data?.length === 0}
      color="blue"
      overlayBlur={2}
      loader={customLoader}
    />
  ) : (
    <div style={{ width: "98%", margin: "auto" }}>
      <Drawer
        opened={openedDetail}
        overlayColor={
          theme.colorScheme === "dark"
            ? theme.colors.dark[9]
            : theme.colors.gray[2]
        }
        overlayOpacity={0.55}
        overlayBlur={3}
        title="Feedback Type Detail"
        padding="xl"
        onClose={() => setOpenedDetail(false)}
        position="bottom"
        size="80%"
      >
        <FeedbackTypeDetailModal
          setOpenedDetail={setOpenedDetail}
          row={feedback}
        />
      </Drawer>
      <Drawer
        opened={opened}
        onClose={() => setOpened(false)}
        padding="xl"
        size="40%"
        styles={{
          closeButton: {
            color: "black",
            marginTop: "50px",
          },
        }}
        position="right"
      >
        <Add fetchData={fetchData} size={size} setOpened={setOpened} />
      </Drawer>
      <Drawer
        opened={openedEdit}
        onClose={() => setOpenedEdit(false)}
        padding="xl"
        size="40%"
        styles={{
          closeButton: {
            color: "black",
            marginTop: "50px",
          },
        }}
        position="right"
      >
        <FeedbackUpdate
          item={editData}
          fetchData={fetchData}
          setOpened={setOpenedEdit}
        />
      </Drawer>

      <Card shadow="sm" p="lg">
        <ScrollArea>
          <SimpleGrid cols={3}>
            <div>
              <Button
                onClick={() => setOpened(true)}
                style={{
                  backgroundColor: "#FF6A00",
                  color: "#FFFFFF",
                  marginBottom: "10px",
                }}
                leftIcon={<Plus size={14} />}
              >
                Add
              </Button>
            </div>
            <div></div>

            <div></div>
          </SimpleGrid>
          <Table style={{ width: "100%", minWidth: "600px" }}>
            <thead>
              <tr style={{ backgroundColor: "#F1F1F1" }}>
                <th>Id</th>
                <th>Name</th>
                <th>Status</th>
                <th>Feedbacks</th>
                <th>Date</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>{rows}</tbody>
          </Table>

          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "12px",
              padding: "6px 4px",
              borderTop: "1px solid #e9ecef",
              flexWrap: "wrap",
              gap: "8px",
            }}
          >
            {/* Left: Total Records */}
            <Text size="sm" style={{ color: "#FF6A00" }}>
              {`Total Records: ${formatNumber(totalRecords)}`}
            </Text>

            {/* Right: Rows select + navigation */}
            <Group spacing={6} noWrap>
              <Text size="sm" color="dimmed">
                Rows
              </Text>
              <Select
                value={size}
                onChange={handlePageSizeChange}
                data={PAGE_SIZE_OPTIONS}
                style={{ width: 72 }}
                size="xs"
              />
              <ActionIcon
                size="sm"
                variant="default"
                onClick={() => handleChange(1)}
                disabled={activePage <= 1}
                title="First page"
                style={{ fontWeight: 700 }}
              >
                «
              </ActionIcon>
              <ActionIcon
                size="sm"
                variant="default"
                onClick={() => handleChange(activePage - 1)}
                disabled={activePage <= 1}
                title="Previous page"
              >
                ‹
              </ActionIcon>
              <Text size="sm" style={{ minWidth: 40, textAlign: "center" }}>
                {activePage} / {totalPages}
              </Text>
              <ActionIcon
                size="sm"
                variant="default"
                onClick={() => handleChange(activePage + 1)}
                disabled={activePage >= totalPages}
                title="Next page"
              >
                ›
              </ActionIcon>
              <ActionIcon
                size="sm"
                variant="default"
                onClick={() => handleChange(totalPages)}
                disabled={activePage >= totalPages}
                title="Last page"
                style={{ fontWeight: 700 }}
              >
                »
              </ActionIcon>
            </Group>
          </div>
        </ScrollArea>
        <Modal
          opened={openedDelete}
          onClose={() => setOpenedDelete(false)}
          title="Warning"
          centered
        >
          <p>Are you sure do you want todelete this data?</p>
          <Group position="right">
            <Button onClick={() => deleteFeedbacktype()} color="red">
              Delete
            </Button>
          </Group>
        </Modal>
      </Card>
    </div>
  );
}
